import React, { FunctionComponent } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Box, constants, OptionProps, Select } from '@match/react-component-library';

const { SPACE } = constants;

interface BrowserDropdownProps {
  onBrowserSelect: (selection?: OptionProps<{}> | undefined) => void;
  supportedBrowsers: string[];
}

export const BrowserDropdown: FunctionComponent<BrowserDropdownProps> = ({
  onBrowserSelect,
  supportedBrowsers,
}) => {
  const intl = useIntl();

  return (
    <Box marginBottom={SPACE.XLARGE}>
      <Box marginBottom={SPACE.SMALL}>
        <FormattedMessage {...messages.browser} />
      </Box>
      <Select
        id="browserSelect"
        buttonAriaLabelClear={intl.formatMessage(messages.selectAriaClear)}
        buttonAriaLabelDownArrow={intl.formatMessage(messages.selectAriaDown)}
        buttonAriaLabelUpArrow={intl.formatMessage(messages.selectAriaUp)}
        name="browserSelect"
        isCombobox
        onSelect={onBrowserSelect}
        placeholder={intl.formatMessage(messages.selectBrowser)}
      >
        {supportedBrowsers.map((supportedBrowser: string) => {
          return (
            <Select.Option key={supportedBrowser} value={supportedBrowser}>
              {supportedBrowser}
            </Select.Option>
          );
        })}
      </Select>
    </Box>
  );
};

const messages = defineMessages({
  browser: {
    id: 'src/modules/pages/ContactUsPage/ContactUsSC3/BrowserDropdown/BrowserDropdown:browser',
    description: 'browser section header',
    defaultMessage: 'Browser',
  },
  selectAriaUp: {
    id: 'src/modules/pages/ContactUsPage/ContactUsSC3/BrowserDropdown/BrowserDropdown:selectAriaUp',
    description: 'up text',
    defaultMessage: 'up',
  },
  selectAriaDown: {
    id:
      'src/modules/pages/ContactUsPage/ContactUsSC3/BrowserDropdown/BrowserDropdown:selectAriaDown',
    description: 'down text',
    defaultMessage: 'down',
  },
  selectAriaClear: {
    id:
      'src/modules/pages/ContactUsPage/ContactUsSC3/BrowserDropdown/BrowserDropdown:selectAriaClear',
    description: 'clear text',
    defaultMessage: 'clear',
  },
  selectBrowser: {
    id:
      'src/modules/pages/ContactUsPage/ContactUsSC3/BrowserDropdown/BrowserDropdown:selectBrowser',
    description: 'select browser dropdown placeholder',
    defaultMessage: 'Select Browser',
  },
});
